import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Icon, { type IconName } from '@/components/ui/Icon';

const NAV_ITEMS: Array<{ path: string; icon: IconName; label: string }> = [
  { path: '/map', icon: 'map', label: '地图' },
  { path: '/timeline', icon: 'scroll-text', label: '足迹' },
  { path: '/subscription', icon: 'crown', label: '会员' },
  { path: '/settings', icon: 'settings', label: '设置' },
];

export default function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 pb-24">
        <Outlet />
      </main>
      <nav className="bottom-nav">
        <div className="bottom-nav-track">
          {NAV_ITEMS.map((item) => {
            const active =
              location.pathname === item.path || location.pathname.startsWith(item.path + '/');
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`bottom-nav-item ${active ? 'active' : ''}`}
              >
                <Icon name={item.icon} size={22} strokeWidth={active ? 2 : 1.5} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
